import { render } from "./GtrGo.vue?vue&type=template&id=781161c5&scoped=true&ts=true"
import script from "./GtrGo.vue?vue&type=script&lang=ts"
export * from "./GtrGo.vue?vue&type=script&lang=ts"

import "./GtrGo.vue?vue&type=style&index=0&id=781161c5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781161c5"]])

export default __exports__